    export const NumberToPercentaje = (value: number, ratio: string): string => {
        if (ratio === "alpha" || ratio === "volatility" || ratio === "max_drawdown" || ratio === "downside_deviation" || ratio === "linear_return") {
            return `${(value * 10000 / 100).toFixed(2) ?? ''}%`
        }
        return value?.toFixed(2);
    }

    export const ReplaceWeightToNumber = (dataWaeight: string) => Number(dataWaeight.replace("%", "").replace(",", "."));